<template>
  <div class="py-1">
    <div :class="previewClicked || previewPopup ? 'grid grid-cols-2 h-85' : ''">
      <div class="col-span-1 overflow-y-auto">
        <div class="bg-white p-5 shadow m-2">
          <form id="basic" @submit.prevent="basicFormSubmit">
            <div class="grid grid-cols-2 items-center">
              <div>
                <div class="text-3xl font-bold inline-block">
                  Lesson Information
                </div>
              </div>
              <div class="text-right">
                <button
                  type="button"
                  @click="updateLesson"
                  :disabled="checkdisable()"
                  class="text-lg btn m-2 btn-primary"
                >
                  Update
                </button>
                <div class="dropdown">
                  <div
                    tabindex="0"
                    v-if="!previewClicked && !previewPopup"
                    class="m-2 text-lg btn btn-primary"
                    :disabled="
                      basicDescription.trim() === '' &&
                      learnAnswer.trim() === '' &&
                      assignmentAnswer.trim() === ''
                    "
                  >
                    Preview
                    <svg
                      class="ml-2 h-4 w-4"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                        clip-rule="evenodd"
                        fill-rule="evenodd"
                      />
                    </svg>
                  </div>
                  <ul
                    tabindex="0"
                    class="
                      p-2
                      shadow
                      menu
                      dropdown-content
                      bg-base-100
                      rounded-box
                      w-48
                    "
                  >
                    <li
                      @click="previewPopup = true"
                      v-if="basicDescription.trim() !== ''"
                    >
                      <a>Site Preview</a>
                    </li>
                    <li
                      @click="formatTweetContent(), (previewClicked = true)"
                      v-if="
                        (learnAnswer.trim() !== '' ||
                          assignmentAnswer.trim() !== '') &&
                        Type === 'twitter'
                      "
                    >
                      <a>Tweet Preview</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="mt-4">
              <div v-if="course.Threadseries" class="flex-nowrap w-full flex justify-between items-center mt-5">
                <input
                type="text"
                placeholder="Thread url (required)"
                class="input input-bordered w-full mb-2"
                required
                v-model="threadurl"
                />
                <button type="button" @click="fetchdata" :disabled="threadurl == '' || threadurl.indexOf('https://twitter.com/') !== 0" class="btn btn-primary w-32 text-lg ml-3 mb-2">
                  Import
                </button>
              </div>
              <input
                type="text"
                placeholder="Title (required)"
                class="input input-bordered w-full mb-2"
                required
                ref="main"
                :disabled="basicForm"
                v-model="basicTitle"
                @input="
                  onEdit();
                  changetakeaway();
                "
              />
              <textarea
                class="textarea h-64 textarea-bordered w-full mb-1"
                placeholder="Description (required)"
                required
                :disabled="basicForm"
                v-model="basicDescription"
                @input="onEdit"
              />
              <input
                type="text"
                placeholder="Estimated Time"
                class="input input-bordered w-full mb-2"
                required
                :disabled="basicForm"
                v-model="basicEstd"
                @input="onEdit"
              />
            </div>
          </form>
        </div>
        <div v-if="Type !== 'mail' && course.showBackground" class="bg-white p-5 shadow m-2">
          <form id="background" @submit.prevent="bgFormSubmit">
            <div class="grid grid-cols-2 items-center">
              <div>
                <input
                  type="checkbox"
                  v-model="showBackground"
                  @input="onEdit"
                  class="toggle mr-3"
                />
                <div class="text-3xl font-bold inline-block">Background</div>
              </div>
              <!--
          <div class="text-right">
            <button
              type="submit"
              class="btn btn-secondary"
              :class="showBackground ? '' : 'btn-disabled'"
            >
              <font-awesome-icon v-if="!bgForm" class="mr-3" size="lg" :icon="['fas', 'lock']" />
              <font-awesome-icon
                v-if="bgForm"
                class="mr-3"
                size="lg"
                :icon="['fas', 'lock-open']"
              />
              {{ bgForm ? 'Unlock' : 'Lock' }}
            </button>
          </div>
          -->
            </div>
            <div class="text-gray-600 ml-1 inline-block">
              Ask a question to ground students about lesson material in the
              context of current topics/projects. can think about existing
              topics/projects that will be relevant to this Lesson
            </div>
            <div v-if="showBackground" class="mt-4">
              <input
                type="text"
                placeholder="Question (required)"
                class="input input-bordered w-full mb-2"
                required
                :disabled="!showBackground || bgForm"
                v-model="bgQuestion"
                @input="onEdit"
              />
              <input
                type="text"
                placeholder="Option 1"
                class="input input-bordered w-full mb-2"
                required
                :disabled="!showBackground || bgForm"
                v-model="bgOption1"
                @input="onEdit"
              />
              <input
                type="text"
                placeholder="Option 2"
                class="input input-bordered w-full mb-2"
                required
                :disabled="!showBackground || bgForm"
                v-model="bgOption2"
                @input="onEdit"
              />
              <input
                type="text"
                placeholder="Option 3"
                class="input input-bordered w-full mb-2"
                required
                :disabled="!showBackground || bgForm"
                v-model="bgOption3"
                @input="onEdit"
              />
              <input
                type="text"
                placeholder="Option 4"
                class="input input-bordered w-full mb-2"
                required
                :disabled="!showBackground || bgForm"
                v-model="bgOption4"
                @input="onEdit"
              />
            </div>
          </form>
        </div>
        <div v-if="!course.Threadseries" class="bg-white p-5 shadow m-2">
          <form id="learn" @submit.prevent="learnFormSubmit">
            <div class="grid grid-cols-1 items-center">
              <div class="flex items-center justify-between">
                <div class="text-3xl font-bold inline-block">Learn</div>
                <div>
                  <input
                    ref="selectedFile"
                    class="w-full mt-3 text-indigo-700 outline-none bg-gray-100"
                    type="file"
                    name="selectedFile"
                    style="display: none"
                    accept="image/jpeg, image/png"
                    @change="onImageUpload"
                    @input="onEdit"
                  />
                  <button
                    type="button"
                    class="btn btn-outline"
                    @click="$refs.selectedFile.click()"
                  >
                    Upload an Image
                  </button>
                </div>
              </div>
              <!--
          <div class="text-right">
            <button type="submit" class="btn btn-secondary">
              <font-awesome-icon v-if="!learnForm" class="mr-3" size="lg" :icon="['fas', 'lock']" />
              <font-awesome-icon
                v-if="learnForm"
                class="mr-3"
                size="lg"
                :icon="['fas', 'lock-open']"
              />
              {{ learnForm ? 'Unlock' : 'Lock' }}
            </button>
          </div>
          -->
            </div>
            <div class="mt-4">
              <textarea
                class="textarea h-64 textarea-bordered w-full mb-1"
                placeholder="Add Main Ideas for the Lesson here. Try to focus on each lesson being a small transforming for your students. (required)"
                required
                :disabled="learnForm"
                v-model="learnAnswer"
                @input="
                  onEdit();
                  formatTweetContent();
                "
              />
            </div>
          </form>
        </div>
        <div v-if="Type !== 'mail' && course.showCheck" class="bg-white p-5 shadow m-2">
          <form id="check" @submit.prevent="checkFormSubmit">
            <div class="grid grid-cols-2 items-center">
              <div>
                <input
                  type="checkbox"
                  @input="onEdit"
                  v-model="showCheck"
                  class="toggle mr-3"
                />
                <div class="text-3xl font-bold inline-block">Check</div>
              </div>
              <!--
          <div class="text-right">
            <button
              type="submit"
              class="btn btn-secondary"
              :class="showCheck ? '' : 'btn-disabled'"
            >
              <font-awesome-icon v-if="!checkForm" class="mr-3" size="lg" :icon="['fas', 'lock']" />
              <font-awesome-icon
                v-if="checkForm"
                class="mr-3"
                size="lg"
                :icon="['fas', 'lock-open']"
              />
              {{ checkForm ? 'Unlock' : 'Lock' }}
            </button>
          </div>
          -->
            </div>
            <div class="text-gray-600 ml-1 inline-block">
              Ask a question to help students verify how much they understand
              what they have just learned.
            </div>
            <div v-if="showCheck" class="mt-4">
              <input
                type="text"
                placeholder="Question (required)"
                class="input input-bordered w-full mb-2"
                required
                :disabled="!showCheck || checkForm"
                v-model="checkQuestion"
                @input="onEdit"
              />
              <input
                type="text"
                placeholder="Option 1"
                class="input input-bordered w-full mb-2"
                required
                :disabled="!showCheck || checkForm"
                v-model="checkOption1"
                @input="onEdit"
              />
              <input
                type="text"
                placeholder="Option 2"
                class="input input-bordered w-full mb-2"
                required
                :disabled="!showCheck || checkForm"
                v-model="checkOption2"
                @input="onEdit"
              />
              <input
                type="text"
                placeholder="Option 3"
                class="input input-bordered w-full mb-2"
                required
                :disabled="!showCheck || checkForm"
                v-model="checkOption3"
                @input="onEdit"
              />
              <input
                type="text"
                placeholder="Option 4"
                class="input input-bordered w-full mb-2"
                required
                :disabled="!showCheck || checkForm"
                v-model="checkOption4"
                @input="onEdit"
              />
            </div>
          </form>
        </div>
        <div v-if="!course.Threadseries"  class="bg-white p-5 shadow m-2">
          <form id="assignment" @submit.prevent="assignmentFormSubmit">
            <div class="grid grid-cols-2 items-center">
              <div>
                <input
                  type="checkbox"
                  v-model="showAssignment"
                  @input="
                    onEdit();
                    onAssignmentchange();
                  "
                  class="toggle mr-3"
                />
                <div class="text-3xl font-bold inline-block">Assignment</div>
              </div>
              <!--
          <div class="text-right">
            <button
              type="submit"
              class="btn btn-secondary"
              :class="showAssignment ? '' : 'btn-disabled'"
            >
              <font-awesome-icon
                v-if="!assignmentForm"
                class="mr-3"
                size="lg"
                :icon="['fas', 'lock']"
              />
              <font-awesome-icon
                v-if="assignmentForm"
                class="mr-3"
                size="lg"
                :icon="['fas', 'lock-open']"
              />
              {{ assignmentForm ? 'Unlock' : 'Lock' }}
            </button>
          </div>
          -->
            </div>
            <div class="text-gray-600 ml-1 inline-block">
              Get students to do *home-work* and promote better understanding of
              lesson concepts
            </div>
            <div v-if="showAssignment" class="mt-4">
              <textarea
                class="textarea h-64 textarea-bordered w-full mb-1"
                placeholder="Description (required)"
                required
                :disabled="!showAssignment || assignmentForm"
                @input="
                  onEdit();
                  formatTweetContent();
                "
                v-model="assignmentAnswer"
              />
              <input
                v-if="course.Enablehashtag"
                type="text"
                placeholder="Hashtag or Assignment Tweet URL"
                class="input input-bordered w-full mb-2"
                required
                :disabled="!showAssignment || assignmentForm"
                v-model="assignmentHashtag"
                @input="
                  onEdit();
                  formatTweetContent();
                "
              />
            </div>
          </form>
        </div>
        <div v-if="course.showFeedback" class="bg-white p-5 shadow m-2">
          <form id="Feedback">
            <div class="grid grid-cols-2 items-center">
              <div>
                <input
                  type="checkbox"
                  :disabled="!showAssignment"
                  v-model="showFeedback"
                  @input="
                    onEdit();
                    onFeedbackchange();
                  "
                  class="toggle mr-3"
                />
                <div class="text-3xl font-bold inline-block">Feedback</div>
              </div>
            </div>
            <div class="text-gray-600 ml-1 inline-block">
              Get students to review assignments done by others.
            </div>
          </form>
        </div>
        <div v-if="course.showParticipate" class="bg-white p-5 shadow m-2">
          <form id="Participate">
            <div class="grid grid-cols-2 items-center">
              <div>
                <input
                  type="checkbox"
                  v-model="showParticipate"
                  :disabled="!showFeedback"
                  @input="onEdit"
                  class="toggle mr-3"
                />
                <div class="text-3xl font-bold inline-block">Participate</div>
              </div>
            </div>
            <div class="text-gray-600 ml-1 inline-block">
              Get students to review and provide feedback to others.
            </div>
          </form>
        </div>
        <div v-if="Type !== 'mail' && !course.Threadseries" class="bg-white p-5 shadow m-2">
          <form id="Tips">
            <div class="grid grid-cols-2 items-center">
              <div>
                <input
                  type="checkbox"
                  :disabled="!showAssignment"
                  v-model="showTips"
                  class="toggle mr-3"
                />
                <div class="text-3xl font-bold inline-block">Tips</div>
              </div>
            </div>
            <div class="text-gray-600 ml-1 inline-block">
              Give students an additional tip for after they have done the
              assignment.
            </div>
            <div v-if="showTips" class="mt-4">
              <textarea
                class="textarea h-32 textarea-bordered w-full mb-2"
                :disabled="!showTips"
                v-model="tips"
                @input="onEdit"
                placeholder="After Assignment Tip (required)"
              />
              <!-- <input
                type="text"
                placeholder="After Assignment Tip"
                class="input input-bordered w-full mb-2"
                :disabled="!showTips"
                @input="onEdit"
                v-model="tips"
              /> -->
            </div>
          </form>
        </div>
        <div v-if="Type !== 'mail' && course.showTakeaway" class="bg-white p-5 shadow m-2">
          <form id="takeaway">
            <div class="grid grid-cols-2 items-center">
              <div>
                <input
                  type="checkbox"
                  v-model="showTakeaway"
                  class="toggle mr-3"
                />
                <div class="text-3xl font-bold inline-block">Takeaway</div>
              </div>
            </div>
            <div class="text-gray-600 ml-1 inline-block">
              Try including the takeaway from the lesson
            </div>
            <div v-if="showTakeaway" class="mt-4">
              <input
                type="text"
                placeholder="Try including the takeaway from the lesson (required)"
                class="input input-bordered w-full mb-2"
                :disabled="!showTakeaway"
                @input="
                  onEdit;
                  takeawayedit = true;
                "
                v-model="takeaway"
              />
            </div>
          </form>
        </div>
      </div>
      <div v-if="previewPopup" class="col-span-1 overflow-y-auto">
        <div class="bg-white p-5 shadow m-2">
          <div class="flex items-center mb-5">
            <div class="text-2xl font-bold inline-block mr-5">
              Live Preview On Site
            </div>
            <svg
              class="ml-auto fill-current text-gray-700 w-6 h-6 cursor-pointer"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 18 18"
              @click="previewPopup = false"
            >
              <path
                d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
              />
            </svg>
          </div>
          <div class="site-wrapper mt-5 ml-5">
            <div class="flex justify-between">
              <h1 class="text-2xl font-medium">{{ basicTitle }}</h1>
            </div>
            <div class="flex justify-between mb-3">
              <div class="flex-col">
                <p v-html="markdownToHTML(basicDescription)" class="text-gray-900 mb-1">
                </p>
                <p class="text-gray-800">ESTD: {{ basicEstd }}</p>
              </div>
            </div>
            <div class="bg-white p-5 mr-5 mb-5 shadow" v-if="showBackground">
              <div class="grid grid-cols-12 items-center mt-2">
                <div class="col-span-11 box-title">Background</div>
              </div>

              <div class="">
                <form>
                  <div>
                    <div class="my-3">
                      <p class="text-md font-bold mb-1">{{ bgQuestion }}</p>
                      <div
                        class="relative flex items-start ml-5"
                      >
                        <div class="flex items-center h-5">
                          <input
                            id="comments"
                            aria-describedby="comments-description"
                            name="comments"
                            type="checkbox"
                            class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
                          />
                        </div>
                        <div class="ml-3 text-sm">
                          <label for="comments" class="font-medium text-gray-900">{{
                            bgOption1
                          }}</label>
                        </div>
                      </div>
                      <div
                        class="relative flex items-start ml-5"
                      >
                        <div class="flex items-center h-5">
                          <input
                            id="comments"
                            aria-describedby="comments-description"
                            name="comments"
                            type="checkbox"
                            class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
                          />
                        </div>
                        <div class="ml-3 text-sm">
                          <label for="comments" class="font-medium text-gray-900">{{
                            bgOption2
                          }}</label>
                        </div>
                      </div>
                      <div
                        class="relative flex items-start ml-5"
                      >
                        <div class="flex items-center h-5">
                          <input
                            id="comments"
                            aria-describedby="comments-description"
                            name="comments"
                            type="checkbox"
                            class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
                          />
                        </div>
                        <div class="ml-3 text-sm">
                          <label for="comments" class="font-medium text-gray-900">{{
                            bgOption3
                          }}</label>
                        </div>
                      </div>
                      <div
                        class="relative flex items-start ml-5"
                      >
                        <div class="flex items-center h-5">
                          <input
                            id="comments"
                            aria-describedby="comments-description"
                            name="comments"
                            type="checkbox"
                            class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
                          />
                        </div>
                        <div class="ml-3 text-sm">
                          <label for="comments" class="font-medium text-gray-900">{{
                            bgOption4
                          }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    type="button"
                    class="btn btn-primary"
                  >
                    Save
                  </button>
                </form>
              </div>
            </div>
            <div v-if="!course.Threadseries" class="bg-white p-5 mr-5 mb-5 shadow">
              <div class="grid grid-cols-12 items-center mt-5">
                <div class="col-span-11 box-title">Learn</div>
              </div>
              <div v-html="markdownToHTML(learnAnswer)" class="box-md mr-5"></div>
              <div class="">
                <!-- TODO Show/Hide this button based on user submission -->
                <button
                  type="button"
                  class="btn btn-primary"
                >
                  Mark as Complete
                </button>
              </div>
            </div>
            <div class="bg-white p-5 mr-5 mb-5 shadow" v-if="showCheck">
              <div class="grid grid-cols-12 items-center mt-2">
                <div class="col-span-11 box-title">Check</div>
              </div>

              <div class="">
                <form>
                  <div>
                    <div class="my-3">
                      <p class="text-md font-bold mb-1">{{ checkQuestion }}</p>
                      <div
                        class="relative flex items-start ml-5"
                      >
                        <div class="flex items-center h-5">
                          <input
                            id="comments"
                            aria-describedby="comments-description"
                            name="comments"
                            type="checkbox"
                            class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
                          />
                        </div>
                        <div class="ml-3 text-sm">
                          <label for="comments" class="font-medium text-gray-900">{{
                            checkOption1
                          }}</label>
                        </div>
                      </div>
                      <div
                        class="relative flex items-start ml-5"
                      >
                        <div class="flex items-center h-5">
                          <input
                            id="comments"
                            aria-describedby="comments-description"
                            name="comments"
                            type="checkbox"
                            class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
                          />
                        </div>
                        <div class="ml-3 text-sm">
                          <label for="comments" class="font-medium text-gray-900">{{
                            checkOption2
                          }}</label>
                        </div>
                      </div>
                      <div
                        class="relative flex items-start ml-5"
                      >
                        <div class="flex items-center h-5">
                          <input
                            id="comments"
                            aria-describedby="comments-description"
                            name="comments"
                            type="checkbox"
                            class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
                          />
                        </div>
                        <div class="ml-3 text-sm">
                          <label for="comments" class="font-medium text-gray-900">{{
                            checkOption3
                          }}</label>
                        </div>
                      </div>
                      <div
                        class="relative flex items-start ml-5"
                      >
                        <div class="flex items-center h-5">
                          <input
                            id="comments"
                            aria-describedby="comments-description"
                            name="comments"
                            type="checkbox"
                            class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
                          />
                        </div>
                        <div class="ml-3 text-sm">
                          <label for="comments" class="font-medium text-gray-900">{{
                            checkOption4
                          }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    type="button"
                    class="btn btn-primary"
                  >
                    Save
                  </button>
                </form>
              </div>
            </div>
            <div
              v-if="showAssignment && !course.Threadseries"
              class="bg-white p-5 mr-5 mb-5 shadow"
            >
              <div class="grid grid-cols-12 items-center mt-5">
                <div class="col-span-11 box-title">Assignment</div>
              </div>
              <div v-html="assignmentAnswer" class="box-md"></div>
              <div class="mt-6">
                <p class="text-sm"
                >
                  <span v-if="assignmentHashtag.indexOf('https://twitter.com/') !== -1">
                    Post assignment by replying to tweet: #<Tweet :id="tweetId" />
                  </span>
                  <span v-else>
                    Post assignment adding the #{{ assignmentHashtag }} to it.
                  </span>
                </p>
                <button
                  type="button"
                  class="btn btn-primary"
                >
                Mark as Done
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="previewClicked" class="col-span-1 overflow-y-auto">
        <div class="bg-white p-5 shadow m-2">
          <div class="flex items-center mb-5">
            <div class="text-2xl font-bold inline-block mr-5">
              Live Preview On Twitter
            </div>
            <svg
              class="ml-auto fill-current text-gray-700 w-6 h-6 cursor-pointer"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 18 18"
              @click="previewClicked = false"
            >
              <path
                d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
              />
            </svg>
          </div>
          <div
            class="tweet-preview"
            v-for="(tweet, index) in tweetPreview"
            :key="index"
          >
            <div class="tweet-preview__header">
              <div class="tweet-preview__header-avatar">
                <img :src="userInfo.user.profilePic" alt="" />
              </div>
              <div class="tweet-preview__header-content">
                <div class="tweet-preview__header-content-name">
                  <a
                    :href="`https://twitter.com/${userInfo.user.acctUsername}`"
                    target="_blank"
                    >{{ userInfo.user.userName }}</a
                  >
                </div>
                <div class="tweet-preview__header-content-screen-name">
                  <a
                    :href="`https://twitter.com/${userInfo.user.acctUsername}`"
                    target="_blank"
                    >@{{ userInfo.user.acctUsername }}</a
                  >
                </div>
              </div>
            </div>
            <div class="tweet-preview__body">
              <div class="tweet-preview__body-text">
                <div
                  class="max-h-144 overflow-auto"
                  v-html="markdownToHTML(tweet)"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <!--
        <div class="site-wrapper mt-5 ml-5">
          <div class="flex justify-between">
            <h1 class="text-2xl font-medium">{{ basicTitle }}</h1>
          </div>
          <div class="flex justify-between mb-3">
            <div class="flex-col">
              <p v-html="markdownToHTML(basicDescription)" class="text-gray-900 mb-1">
              </p>
              <p class="text-gray-800">ESTD: {{ basicEstd }}</p>
            </div>
          </div>
        </div>
        -->
      </div>
    </div>
    <transition
      enter-active-class="transition duration-300 ease-out transform"
      enter-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-150 ease-in transform"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div
        v-if="feedPopup"
        class="
          flex
          items-center
          justify-center
          fixed
          left-0
          bottom-0
          w-full
          h-full
        "
        style="background-color: #00000099"
      >
        <div class="bg-white rounded-lg w-1/4">
          <div class="flex flex-col items-start p-4">
            <div class="flex items-center w-full">
              <div class="text-gray-900 font-bold text-lg">
                Do you really want to leave? You have unsaved changes !
              </div>
            </div>
            <br />
            <div class="ml-auto">
              <button class="btn btn-primary" @click="nextpage">leave</button>
              <button class="btn btn-outline ml-3" @click="feedPopup = false">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import showdown from 'showdown';
import lessonAPI from '@/services/lesson';
import userInfo from '@/services/userInfo';
import courseAPI from '@/services/course';
import store from '@/store';
import utils from '@/services/utils';

export default {
  name: 'topics',
  layout: 'admin',
  store,
  data() {
    return {
      course: {},
      userInfo: null,
      courseId: null,
      lessonId: null,
      basicForm: false,
      bgForm: false,
      learnForm: false,
      checkForm: false,
      assignmentForm: false,
      basicTitle: '',
      threadurl: '',
      basicDescription: '',
      basicEstd: '',
      takeaway: 'Finished <Lesson Name> !',
      showTakeaway: true,
      showTips: false,
      showParticipate: false,
      showFeedback: false,
      tips: '',
      bgQuestion: '',
      bgOption1: '',
      bgOption2: '',
      bgOption3: '',
      bgOption4: '',
      learnAnswer: '',
      checkQuestion: '',
      checkOption1: '',
      checkOption2: '',
      checkOption3: '',
      checkOption4: '',
      assignmentAnswer: '',
      assignmentHashtag: '',
      showBackground: true,
      showCheck: true,
      showAssignment: true,
      feedPopup: false,
      autosave: null,
      nextpage: null,
      ischange: false,
      takeawayedit: false,
      previewPopup: false,
      finalTweetArray: [],
      tweetArray: [],
      Type: '',
      tweetPreview: [],
      previewtype: '',
      previewClicked: false,
      image: null,
    };
  },
  computed: {
    user() {
      return store.state.user;
    },
  },
  async mounted() {
    document.querySelector('base').href = 'https://res.cloudinary.com/implicit/image/upload/';
    this.$refs.main.focus();
    window.addEventListener('beforeunload', (e) => {
      document.querySelector('base').href = '';
      if (this.ischange) {
        e.preventDefault();
        e.returnValue = '';
      }
    });
    this.courseId = this.$route.params.courseId;
    this.lessonId = this.$route.params.lessonId;
    store.commit('toggleLoading', true);
    this.courseData = await courseAPI.getCourse(this.courseId);
    this.Type = this.courseData.course.type;
    this.course = this.courseData.course;
    this.userInfo = await userInfo.getUserInfo(this.user.uid);
    this.fetchLesson();
  },
  beforeDestroy() {
    document.querySelector('base').href = '';
    clearTimeout(this.autosave);
  },
  beforeRouteLeave(to, from, next) {
    document.querySelector('base').href = '';
    if (this.ischange) {
      this.feedPopup = true;
      this.nextpage = next;
    } else {
      next();
    }
  },

  methods: {
    async onImageUpload(e) {
      store.commit('toggleLoading', true);
      if (e.target.files.length > 0) {
        [this.image] = e.target.files;
        let secureUrl = '';
        if (this.image !== null) {
          const cloudName = 'implicit';
          const formData = new FormData();
          formData.append('upload_preset', 'lessons');
          formData.append('file', this.image);
          if (this.image) {
            const res = await axios
              .post(
                `https://api.cloudinary.com/v1_1/${cloudName}/upload`,
                formData,
                {
                  transformRequest: (data, headers) => {
                    // eslint-disable-next-line no-param-reassign
                    delete headers.common.Authorization;
                    return data;
                  },
                },
              )
              .catch((err) => console.log(err));
            if (res) {
              secureUrl = res.data.secure_url.replace(
                'https://res.cloudinary.com/implicit/image/upload/',
                '',
              );
            }
          }
        }
        // width and height of image
        this.learnAnswer = `${this.learnAnswer}\n![image](${secureUrl})\n`;
        // set the <base> tag to the image url
        this.formatTweetContent();
      }
      store.commit('toggleLoading', false);
    },
    checkdisable() {
      let res = false;
      if (
        (!this.course.Threadseries && this.learnAnswer.trim() === '') ||
        this.basicDescription.trim() === '' ||
        // this.basicEstd.trim() === '' ||
        this.basicTitle.trim() === ''
      ) {
        res = true;
      } else if (
        this.showBackground &&
        (this.bgQuestion.trim() === '' ||
          this.bgOption1.trim() === '' ||
          this.bgOption2.trim() === '' ||
          this.bgOption3.trim() === '' ||
          this.bgOption4.trim() === '')
      ) {
        res = true;
      } else if (
        this.showCheck &&
        (this.checkQuestion.trim() === '' ||
          this.checkOption1.trim() === '' ||
          this.checkOption2.trim() === '' ||
          this.checkOption3.trim() === '' ||
          this.checkOption4.trim() === '')
      ) {
        res = true;
      } else if (
        this.showAssignment && !this.course.Threadseries &&
        (this.assignmentAnswer.trim() === '')
      ) {
        res = true;
      } else if (this.showTips && !this.course.Threadseries && this.tips.trim() === '') {
        res = true;
      } else if (this.showTakeaway && this.takeaway.trim() === '') {
        res = true;
      }
      return res;
    },
    basicFormSubmit() {
      this.basicForm = !this.basicForm;
    },
    fetchdata() {
      store.commit('toggleLoading', true);
      console.log(this.threadurl, this.userInfo);
      lessonAPI
        .getdatafromurl({ userObj: this.userInfo.user, tweeturl: this.threadurl })
        .then((res) => {
          const tweet = res.data.data.full_text;
          this.basicTitle = tweet.slice(0, tweet.indexOf('\n'));
          this.basicDescription = tweet.slice(tweet.indexOf('\n') + 1);
          store.commit('toggleLoading', false);
        })
        .catch((error) => {
          store.commit('toggleLoading', false);
          if (error.response.status === 401) {
            utils.setStatusMsg(
              this,
              'Unauthorized access, redirected to implicit',
            );
            this.$router.push({ path: '/' });
          }
          console.log({ error });
        });
    },
    changetakeaway() {
      if (!this.takeawayedit) {
        this.takeaway = `Finished ${this.basicTitle} !`;
      }
    },
    markdownToHTML(md) {
      const description = md.replace(/\n/g, '<br>');
      const converter = new showdown.Converter();
      return converter.makeHtml(description);
    },
    onEdit() {
      console.log('edit');
      this.ischange = true;
      clearTimeout(this.autosave);
      this.autosave = setTimeout(() => this.autosaveLesson(), 10000);
    },
    bgFormSubmit() {
      this.bgForm = !this.bgForm;
    },
    learnFormSubmit() {
      this.learnForm = !this.learnForm;
    },
    checkFormSubmit() {
      this.checkForm = !this.checkForm;
    },
    assignmentFormSubmit() {
      this.assignmentForm = !this.assignmentForm;
    },
    onAssignmentchange() {
      if (this.showAssignment) {
        this.showFeedback = false;
        this.showTips = false;
        this.showParticipate = false;
      }
    },
    onFeedbackchange() {
      if (this.showFeedback) {
        this.showParticipate = false;
      }
    },
    fetchLesson() {
      store.commit('toggleLoading', true);
      lessonAPI
        .getLesson(this.lessonId)
        .then((result) => {
          store.commit('toggleLoading', false);
          if (result.lesson) {
            const lesson = result.lesson ? result.lesson : null;
            this.basicTitle = lesson.title;
            this.threadurl = lesson.tweetUrl;
            this.basicDescription = lesson.description;
            this.basicEstd = lesson.estdTime;

            this.bgQuestion = lesson.background[0].title;
            [this.bgOption1, this.bgOption2, this.bgOption3, this.bgOption4] =
              lesson.background[0].options;

            this.learnAnswer = lesson.learn;

            this.checkQuestion = lesson.check[0].title;
            [
              this.checkOption1,
              this.checkOption2,
              this.checkOption3,
              this.checkOption4,
            ] = lesson.check[0].options;

            this.assignmentAnswer = lesson.assignment;
            this.assignmentHashtag = lesson.hashtag;

            this.showBackground = lesson.showBackground;
            this.showCheck = lesson.showCheck;
            this.showAssignment = lesson.showAssignment;
            this.showTakeaway = lesson.showTakeaway;
            this.showTips = lesson.showTips;
            this.showParticipate = lesson.showParticipate;
            this.showFeedback = lesson.showFeedback;
            this.tips = lesson.tips;
            this.takeaway = !lesson.takeaway
              ? `Finished ${this.basicTitle} !`
              : lesson.takeaway;
            this.takeawayedit = this.takeaway !== `Finished ${this.basicTitle} !`;
          } else {
            this.$router.push({ path: '/admin/products' });
            utils.setStatusMsg(
              this,
              'Lesson not found',
            );
          }
        })
        .catch((error) => {
          store.commit('toggleLoading', false);
          console.log(error);
          if (error.response.status === 401) {
            utils.setStatusMsg(
              this,
              'Unauthorized access, redirected to implicit',
            );
            this.$router.push({ path: '/' });
          }
          console.log({ error });
        });
    },
    updateLesson() {
      store.commit('toggleLoading', true);
      lessonAPI
        .updateLesson(this.lessonId, {
          title: this.basicTitle,
          tweetUrl: this.threadurl,
          description: this.basicDescription,
          estdTime: this.basicEstd,
          userId: this.userInfo.user.userId,
          background: [
            {
              type: 'checkbox',
              required: true,
              title: this.bgQuestion,
              options: [
                this.bgOption1,
                this.bgOption2,
                this.bgOption3,
                this.bgOption4,
              ],
            },
          ],
          learn: this.learnAnswer,
          takeaway: this.takeaway,
          tips: this.tips,
          check: [
            {
              type: 'checkbox',
              required: true,
              title: this.checkQuestion,
              options: [
                this.checkOption1,
                this.checkOption2,
                this.checkOption3,
                this.checkOption4,
              ],
            },
          ],
          assignment: this.assignmentAnswer,
          hashtag: this.assignmentHashtag,
          mentionUser: {
            screen_name: this.userInfo.user.acctUsername,
            name: this.userInfo.user.userName,
            id: this.userInfo.user.id || null,
            id_str: `${this.userInfo.user.id || ''}`,
          },
          type: 'twitter_engagement',
          badge: [],
          feedback: [],
          participate: [],
          showBackground: this.showBackground,
          showLearn: true,
          showCheck: this.showCheck,
          showAssignment: this.showAssignment,
          showTakeaway: this.showTakeaway,
          showTips: this.showTips,
          showParticipate: this.showParticipate,
          showFeedback: this.showFeedback,
        })
        .then(() => {
          this.ischange = false;
          store.commit('toggleLoading', false);
          this.$router.push('/admin/products');
        })
        .catch((error) => {
          store.commit('toggleLoading', false);
          if (error.response.status === 401) {
            utils.setStatusMsg(
              this,
              'Unauthorized access, redirected to implicit',
            );
            this.$router.push({ path: '/' });
          }
          console.log({ error });
        });
    },
    autosaveLesson() {
      lessonAPI
        .updateLesson(this.lessonId, {
          title: this.basicTitle,
          tweetUrl: this.threadurl,
          description: this.basicDescription,
          estdTime: this.basicEstd,
          userId: this.userInfo.user.userId,
          background: [
            {
              type: 'checkbox',
              required: true,
              title: this.bgQuestion,
              options: [
                this.bgOption1,
                this.bgOption2,
                this.bgOption3,
                this.bgOption4,
              ],
            },
          ],
          learn: this.learnAnswer,
          takeaway: this.takeaway,
          tips: this.tips,
          check: [
            {
              type: 'checkbox',
              required: true,
              title: this.checkQuestion,
              options: [
                this.checkOption1,
                this.checkOption2,
                this.checkOption3,
                this.checkOption4,
              ],
            },
          ],
          assignment: this.assignmentAnswer,
          hashtag: this.assignmentHashtag,
          mentionUser: {
            screen_name: this.userInfo.user.acctUsername,
            name: this.userInfo.user.userName,
            id: this.userInfo.user.id || null,
            id_str: `${this.userInfo.user.id || ''}`,
          },
          type: 'twitter_engagement',
          badge: [],
          feedback: [],
          participate: [],
          showBackground: this.showBackground,
          showLearn: true,
          showCheck: this.showCheck,
          showAssignment: this.showAssignment,
          showTakeaway: this.showTakeaway,
          showTips: this.showTips,
          showParticipate: this.showParticipate,
          showFeedback: this.showFeedback,
        })
        .then(() => {
          console.log('lession updated');
          this.ischange = false;
        })
        .catch((error) => {
          store.commit('toggleLoading', false);
          if (error.response.status === 401) {
            utils.setStatusMsg(
              this,
              'Unauthorized access, redirected to implicit',
            );
            this.$router.push({ path: '/' });
          }
          console.log({ error });
        });
    },
    formatTweetContent() {
      this.tweetPreview = [];
      const initailTweetArray = []; // Initial tweet array for description having new lines
      const finalTweetArray = []; // Final tweet array for description having new lines
      const tweetArray = []; // tweet array for description doesn't having new lines
      let tweet = '';
      const regex = /!\[(.*?)\)/g;
      const maxTweetLength = 280;
      // slice the matching regex from the this.tweetPreview[i]
      const uderscoreMatch = `${this.learnAnswer} \n\n\n ${this.assignmentAnswer}`;
      // replace underscore with backslash
      const basicDescription = uderscoreMatch.replace(/_/g, '\\_');
      const numberofLineBreaks = (basicDescription.match(/\n\n\n/g) || [])
        .length;

      for (let i = 0; i <= numberofLineBreaks; i += 1) {
        initailTweetArray.push(basicDescription.split('\n\n\n')[i]);
      }

      if (numberofLineBreaks > 0 && initailTweetArray.length >= 1) {
        const urlRegex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi; // eslint-disable-line
        for (let i = 0; i < initailTweetArray.length; i += 1) {
          tweet = initailTweetArray[i];
          let max = maxTweetLength;
          for (let j = 1; tweet.length > maxTweetLength || tweet.match(urlRegex) !== null; j += 1) {
            // const firsttweet = tweet.slice(0, max);
            // regex to match the url
            let matchcount = 0;
            const match1 = tweet.match(urlRegex);
            if (match1) {
              let lastindex = 0;
              match1.forEach((element) => {  // eslint-disable-line
                const currenttweet = tweet.substring(lastindex, tweet.length);
                if ((currenttweet.indexOf(element) + lastindex) < (max + matchcount - 25)) { // eslint-disable-line
                  matchcount = element.length - 25 + matchcount;
                  lastindex = element.length + tweet.indexOf(element);
                }
              });
            }
            const match = tweet.match(regex);
            if (match) {
              let lastindex = 0;
              match.forEach((element) => {  // eslint-disable-line
                const currenttweet = tweet.substring(lastindex, tweet.length);
                const nexttweet = tweet.substring(max + matchcount).trim();
                if ((currenttweet.indexOf(element) + lastindex) < max + matchcount) { // eslint-disable-line
                  matchcount += element.length;
                } else if (nexttweet.indexOf(element) === 0) {
                  matchcount = tweet.indexOf(element) - max + element.length;
                }
                lastindex = element.length + currenttweet.indexOf(element) + lastindex;
              });
            }
            max += matchcount;
            while (tweet.charAt(max) === ' ' || tweet.charAt(max) === '' || tweet.charAt(max) === '\n') {
              finalTweetArray.push(tweet.substring(0, max).trim());
              tweet = tweet.substring(max);
              if (tweet.length <= maxTweetLength) {
                finalTweetArray.push(tweet.trim());
                tweet = '';
                break;
              } else {
                max = tweet.charAt(max) !== ' ' || tweet.charAt(max) !== '' || tweet.charAt(max) !== '\n' ? maxTweetLength + 1 : maxTweetLength;
                matchcount = 0;
              }
            }
            if (tweet.charAt(max) !== ' ' || tweet.charAt(max) !== '' || tweet.charAt(max) !== '\n') {
              max -= 1;
              max -= matchcount;
            }
          }

          if (tweet.length <= maxTweetLength) {
            finalTweetArray.push(tweet.trim());
          }
        }
      }

      this.tweetPreview = numberofLineBreaks > 0 && finalTweetArray.length >= 1 ? finalTweetArray : tweetArray;

      // if (numberofLineBreaks > 0 && finalTweetArray.length >= 1) {
      //   for (let i = 0; i < finalTweetArray.length; i += 1) {
      //     if (finalTweetArray[i] !== '') {
      //       if (finalTweetArray[i].includes('\n')) {
      //         this.tweetPreview.push(finalTweetArray[i].replace(/\n/g, '<br>'));
      //       } else {
      //         this.tweetPreview.push(finalTweetArray[i]);
      //       }
      //     }
      //   }
      // }

      // if (numberofLineBreaks === 0 && tweetArray.length >= 1) {
      //   for (let i = 0; i < tweetArray.length; i += 1) {
      //     if (tweetArray[i] !== '') {
      //       if (tweetArray[i].includes('\n')) {
      //         this.tweetPreview.push(tweetArray[i].replace(/\n/g, '<br>'));
      //       } else {
      //         this.tweetPreview.push(tweetArray[i]);
      //       }
      //     }
      //   }
      // }
      for (let i = 0; i < this.tweetPreview.length; i += 1) {
        // slice the matching regex from the this.tweetPreview[i]
        const match = this.tweetPreview[i].match(regex);
        if (match) {
          for (let j = 0; j < match.length; j += 1) {
            let image = match[j];
            this.tweetPreview[i] = this.tweetPreview[i].replace(image, '');
            image = j % 2 === 0 ? ` <br> <br> ${match[j].slice(0, -1)} =48%x* ${match[j].slice(-1)}` : `${match[j].slice(0, -1)} =48%x* ${match[j].slice(-1)}`;
            this.tweetPreview[i] = `${this.tweetPreview[i]} ${image}`;
          }
        }
      }
      const lasttweets = [];
      for (let i = 0; i < this.tweetPreview.length; i += 1) {
        // remove array item if it is empty
        if (this.tweetPreview[i].trim().length !== 0) {
        // slice the matching regex from the this.tweetPreview[i]
          const match = this.tweetPreview[i].match(/\n/g);
          if (match) {
            for (let j = 0; j < match.length; j += 1) {
              if (this.tweetPreview[i].trim().indexOf(match[j]) === 0) {
                this.tweetPreview[i] = this.tweetPreview[i].trim().substring(match[j].length);
              }
            }
          }
          lasttweets.push(this.tweetPreview[i]);
        }
      }
      console.log(this.tweetPreview);
      this.tweetPreview = lasttweets;
      return this.tweetPreview;
    },
  },
};
</script>

<style>
.top-right {
  top: 1.5rem;
  right: 4rem;
}
.tweet-preview {
  border: 1px solid #e1e8ed;
  border-radius: 3px;
  padding: 10px;
  margin-bottom: 10px;
}
.tweet-preview__header {
  display: flex;
  align-items: center;
}
.tweet-preview__header-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;
}
.tweet-preview__header-content {
  flex: 1;
}
.tweet-preview__header-content-name {
  font-weight: bold;
  margin-bottom: 5px;
}
.tweet-preview__header-content-screen-name {
  color: #8e8e8e;
}
.tweet-preview__body {
  margin-top: 10px;
}
.tweet-preview__body-text {
  margin-bottom: 10px;
}
.tweet-preview__body-text img {
  display: inline-block;
}
.tweet-preview__body-media {
  margin-top: 10px;
}
.tweet-preview__footer {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.tweet-preview__footer-actions {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.tweet-preview__footer-actions-reply {
  margin-right: 10px;
}
.tweet-preview__footer-actions-retweet {
  margin-right: 10px;
}
.box-title {
  --text-opacity: 1;
  color: rgba(7,34,91,var(--text-opacity));
  font-size: 1.25rem;
  display: flex;
  margin-bottom: 1.25rem;
  cursor: default;
  font-weight: 900;
}
</style>
